import { render, staticRenderFns } from "./NavbarDeliveryService.vue?vue&type=template&id=41c45a3a&"
import script from "./NavbarDeliveryService.vue?vue&type=script&lang=js&"
export * from "./NavbarDeliveryService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports